import { render } from "./SecretOrigin.vue?vue&type=template&id=e4240e1a&scoped=true"
import script from "./SecretOrigin.vue?vue&type=script&lang=js"
export * from "./SecretOrigin.vue?vue&type=script&lang=js"

import "./SecretOrigin.vue?vue&type=style&index=0&id=e4240e1a&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4240e1a"]])

export default __exports__